/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-19 13:21:42
 * @LastEditTime: 2024-03-08 11:06:11
 * @Descripttion: file content
 */
import {
	AppModule,
	AreaType,
	BookCollection,
	DubbingDataType,
	PaperDetail,
	PublishParam,
	PublishedDetailType,
	TargetUser,
	schoolItem,
	ClassListType,
	CopyStuType,
	LoginInfo,
	AreaObjType
} from '@/types/api'
import md5 from 'md5'
import http from './http'
import {LoginInfoType} from '@/types/tea'
import {BookCategoryType, BookType, GradesType, HomeWorkItemType, UnitType} from '@/types/homework'
import {gradeBookType, MODE, styleConf} from '@/utils/const'
import {TEA_API, UC_API, PC_API} from './api'
import {QuePubType} from '@/types/question'
import {CheckListType} from '@/types/check'
import {PRODUCT} from '@/project.config'

const getArea = async () => await http<AreaType[]>({url: UC_API.getArea})

const getSchoolList = async ({
	borough_id,
	city_id,
	province_id
}: {
	borough_id: number
	city_id: number
	province_id: number
}) => {
	return await http<schoolItem[]>({
		url: UC_API.getSchoolList,
		params: {
			province_id,
			city_id,
			borough_id
		}
	})
}

const getLoginInfo = async () => {
	const res = await http<LoginInfoType>({url: PC_API.getLoginInfo})
	return {
		name: res.name,
		school_id: res.school_id,
		user_type: Number(res.user_type),
		borough_id: res.school_info?.borough_id,
		school_info: res.school_info
	}
}

const getAppConfModule = async () => {
	const res = await http<AppModule[]>({url: PC_API.getAppConfModule})
	return [
		{
			comp: 'entry',
			module: [
				{
					list: res.map(_ => {
						return {
							title: _.name,
							mode: 'homework_speak',
							pic: _.pic
						}
					})
				}
			]
		}
	]
}

const getCheckList = async (data: {page: number; page_size: number; status: number}) => {
	const res = await http<HomeWorkItemType[]>({url: PC_API.getCheckList, data})
	return res
}

const getGrades = async (mode: MODE, section: number) => {
	return await http<GradesType[]>({
		url: TEA_API.getGrades,
		params: {
			book_type: gradeBookType[mode],
			section
		}
	})
}

const getUnits = async (book_id: number, mode: MODE) => {
	const book_type = mode === MODE.HOMEWORK_UNFINISH ? 1 : 2
	const style = mode === MODE.HOMEWORK_UNFINISH ? 10 : 11
	return await http<UnitType[]>({url: TEA_API.getUnits, params: {book_type, book_id, style}})
}

const getCategoryBooks = async (grade: number, mode: MODE) => {
	const book_type = mode === MODE.HOMEWORK_UNFINISH ? 1 : 2
	return await http<BookType[] | BookCategoryType[]>({url: TEA_API.getCategoryBooks, params: {book_type, grade}})
}

const getQuesDetails = async (ids: number[], page: number, mode: MODE) => {
	return await http<QuePubType[]>({
		url: TEA_API.getQuesDetails,
		params: {
			home_type: styleConf[mode],
			page,
			ids
		}
	})
}

const getTargetUser = async (grade_class = 0) => {
	return await http<TargetUser[]>({
		url: TEA_API.getTargetUser,
		params: {
			grade_class
		}
	})
}

const getDefaultName = async (title: string, mode: MODE) => {
	const url = PC_API.getDefaultName
	return await http<{title: string}>({
		url,
		data: {
			title
		}
	})
}

export interface CheckType {
	page: number
	page_size?: number
	status: number
}
const getPraCheckL = async (params: CheckType) => {
	return await http<CheckListType[]>({
		url: TEA_API.getPraCheckL,
		params
	})
}
const getExamCheckL = async (params: CheckType) => {
	return await http<any>({
		url: TEA_API.getExamCheckL,
		params
	})
}

const publish = async (data: PublishParam) => {
	return await http<{title: string}>({
		url: PC_API.publishMentor,
		data
	})
}

const getPapertype = async () => await http<{name: string; paper_type: number}[]>({url: TEA_API.getPapertype})

const getExamList = async (collection_id: number) => {
	return await http<PaperDetail[]>({
		url: PC_API.getExamList,
		method: 'POST',
		data: {set_id: collection_id, page: 1, page_size: 100}
	})
}

const getPaperDetail = async (id: number) => {
	return await http<PaperDetail[]>({url: PC_API.getPaperDetail, data: {paper_id: id}})
}

const getCollectionList = async () => {
	return await http<BookCollection[]>({url: PC_API.getCollectionList})
}

const getPhonetics = async (options: {type: number; published: number}) => {
	return await http<{list: QuePubType[]}>({url: TEA_API.getPhonetics, params: options})
}

const getDubbing = async (options: {grade: number; is_published: number; category: number; page: number}) => {
	return await http<DubbingDataType>({url: TEA_API.getDubbing, params: {...options, limit: 5}})
}

const getDubbGrades = async () => {
	return await http<{id: number; name: string}[]>({url: TEA_API.getDubbGrades})
}
const getDubbCategories = async () => {
	return await http<{id: number; name: string}[]>({url: TEA_API.getDubbCategories})
}
const getPaperType = async () => {
	return await http<{paper_type: number; name: string}[]>({url: TEA_API.getPaperType})
}

const getQuesList = async (options: {
	grade?: number
	published?: number
	exam_type?: number
	is_vip?: number
	tag_id?: number
}) => {
	return await http<UnitType[]>({url: TEA_API.getQuesList, params: options})
}

const getPublishedDetail = async (id: number, mode: MODE) => {
	const isPcExam = mode === MODE.MACHINE_EXAM || mode === MODE.MACHINE_WORK
	const url = isPcExam ? TEA_API.getPcExamPublishedDetail : TEA_API.getMentorPublishedDetail
	const params = isPcExam ? {exam_id: id} : {home_id: id}
	return await http<PublishedDetailType>({url, params})
}

const getClassList = async (id?: number, origin?: string) => {
	let params = {}
	if (origin) {
		params = origin === 'exam' ? {exam_id: id} : {home_id: id}
	}
	return await http<ClassListType[]>({url: TEA_API.getCLassList, params})
}

const getHomeworkD = async (params: {home_id: number; class_id: number}) => {
	return await http<any>({url: TEA_API.getHomeworkDetail, params})
}

const getContentInfo = async (params: {home_id: number; class_id: number}) => {
	return await http<any>({url: TEA_API.getContentInfo, params})
}

const getCopyStudent = async (params: {home_id: number; class_id: number}) => {
	return await http<CopyStuType[]>({url: TEA_API.getCopyStudent, params})
}
const hurry = async (params: {home_id: number; class_id: number}) => {
	return await http<any[]>({url: TEA_API.hurry, params})
}

const sendCode = async (phone: number) => {
	return await http<any>({
		url: UC_API.sendCode,
		method: 'POST',
		data: {
			phone,
			scene: 'forgetpwd',
			product: PRODUCT,
			client_key: 'app_teacher'
		}
	})
}

const resetPwd = async (phone: number, code: string, password: string) => {
	return await http<any>({
		url: UC_API.resetPwd,
		method: 'POST',
		data: {phone, code, pwd: md5(password), product: PRODUCT, utype: 1, client_key: 'app_teacher'}
	})
}

// class_id 可选
const deleteHomework = async (data: {home_id: number; class_id?: number}) => {
	return await http<any[]>({url: TEA_API.deleteHomework, data, method: 'POST'})
}

const receiveHomework = async (home_id: number) => {
	return await http<any[]>({url: TEA_API.receiveHomework, data: {home_id}, method: 'POST'})
}

const login = async (data: LoginInfo) => {
	const bodyData = {
		account: data.account,
		password: data.pwd,
		user_type: data.login_type === 'admin' ? 5 : 6
	}
	return await http<{
		bind_phone: string
		token: string
		uid: string
		accounts?: any[]
	}>({url: PC_API.login, data: bodyData, method: 'POST'})
}

const getPersonScore = async (params: any) => {
	return await http<any>({url: TEA_API.getPersonScore, params})
}

const getPersonTopic = async (params: any) => {
	return await http<any>({url: TEA_API.getPersonTopic, params})
}

const backHomework = async (params: {home_id: number; stu_uid: number[]}) => {
	return await http<any>({url: TEA_API.backHomework, params})
}

const getAreaList = async (data: any) => await http<AreaObjType[]>({url: PC_API.getAreaList, data})

const getSchoolListPC = async (data: {borough_id: number}) => await http<any>({url: PC_API.getSchoolList, data})

const getClassListPC = async (data: {school_id: number}) => await http<any>({url: PC_API.getClassList, data})

const savePublishStu = async (data: {publish_stu_json: string}) => await http<any>({url: PC_API.savePublishStu, data})

const getAnalysis = async (data: {race_id: number; school_id: number}) =>
	await http<any>({url: PC_API.getAnalysis, data})

const getCompletion = async (data: any) => await http<any>({url: PC_API.getCompletion, data})

const publishUser = async (data: any) => await http<any>({url: PC_API.publishUser, data})

const delRace = async (data: any) => await http<any>({url: PC_API.delRace, data})

const getPaperReport = async (data: any) => await http<any>({url: PC_API.getPaperReport, data})

const getRaceContent = async (data: any) => await http<any>({url: PC_API.getRaceContent, data})

const logout = async () => await http<any>({url: PC_API.logout})

const exportUser = async (data: any) => await http<any>({url: PC_API.exportUser, data})

export default {
	getArea,
	login,
	getSchoolList,
	getLoginInfo,
	getAppConfModule,
	getCheckList,
	getUnits,
	deleteHomework,
	receiveHomework,
	getQuesList,
	getPhonetics,
	getPaperType,
	getDubbing,
	getCategoryBooks,
	getGrades,
	getQuesDetails,
	getTargetUser,
	getDefaultName,
	getPapertype,
	getCollectionList,
	getPaperDetail,
	getExamList,
	sendCode,
	publish,
	resetPwd,
	getPraCheckL,
	getExamCheckL,
	getDubbGrades,
	getDubbCategories,
	getPublishedDetail,
	getCopyStudent,
	hurry,
	getClassList,
	getHomeworkD,
	getContentInfo,
	getPersonScore,
	getPersonTopic,
	backHomework,
	getAreaList,
	getSchoolListPC,
	getClassListPC,
	savePublishStu,
	getAnalysis,
	getCompletion,
	publishUser,
	delRace,
	getPaperReport,
	getRaceContent,
	logout,
	exportUser
}
